import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class DropHUD extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene);

    this.scoreLabel = ABCyaPhaser.Text.addText(10, 0, 30, 0xffffff, FontKeys._BPreplay_Bold, 'SCORE: ', this, false).setOrigin(0);
    this.scoreText = ABCyaPhaser.Text.addText(this.scoreLabel.width + 15, 0, 30, 0xffffff, FontKeys._BPreplay_Bold, '0', this, false).setOrigin(0);

    this.goalLabel = ABCyaPhaser.Text.addText(0, 0, 22, 0xffffff, FontKeys._BPreplay_Bold, 'MAKE', this, false).setOrigin(0);
    this.goalLabel.x = this.scene.scale.width / 2 - this.goalLabel.width / 2;
    this.goalText = ABCyaPhaser.Text.addText(this.scene.scale.width / 2, 20, 44, 0xffffff, FontKeys._BPreplay_Bold, 'X', this, false).setOrigin(0.5, 0);
  }
}